import React, { useState, useEffect, useRef } from 'react';
import './RadioButtonListInput.css';
import validate from '../../common/validate';
import logComponent from '../../common/logComponent';
import RadioButtonGroup from '../RadioButtonGroup/RadioButtonGroup';

export default function RadioButtonListInput({ initialValue, label, name, showError, errorMessage, rules, onValidate, items, onSelect }) {
  const [value, setValue] = useState(initialValue ? initialValue : '');
  const [validationDetails, setValidationDetails] = useState(null);
  const [isValid, setIsValid] = useState(null);
  const [needsValidation, setNeedsValidation] = useState(false);
  const valueRef = useRef(initialValue ? initialValue : '');
  const isValidating = useRef(false);

const setValueRef = (el) => {
  if (logComponent('RadioButtonListInput')) { console.debug('RadioButtonListInput setValueRef'); }
  setValue(el);
  valueRef.current = el;
}

  if (logComponent('RadioButtonListInput')) { console.debug('RadioButtonListInput rendered'); }

  useEffect(() => {
    if (logComponent('RadioButtonListInput')) { console.debug('RadioButtonListInput onMount'); }

    if (value) validateThis();
  }, [])


  useEffect(() => {
    if (logComponent('RadioButtonListInput')) { console.debug('RadioButtonListInput useEffect [value]'); }

    if (showError) validateThis();
  }, [value])

  useEffect(() => {
    if (logComponent('RadioButtonListInput')) { console.debug('RadioButtonListInput useEffect [initialValue]'); }

    setValue(initialValue);
    validateThis();
  }, [initialValue])

  useEffect(() => {
    if (logComponent('SelectInput')) { console.debug('SelectInput useEffect [showError]'); }
    if (isValidating) return;
    if (showError) validateThis();
  }, [showError])

  useEffect(() => {
    if (logComponent('SelectInput')) { console.debug('SelectInput useEffect [needsValidation]'); }
    if (isValidating) return;
    if (needsValidation === true) {
      validateThis();
      setNeedsValidation(false);
    }
  }, [needsValidation])

  const updateValue = (e) => {
    if (logComponent('RadioButtonListInput')) { console.debug('RadioButtonListInput updateValue'); }
    setValueRef(e);
    setNeedsValidation(validateThis());


    if (onSelect) {
      onSelect(e.text);
    }

  }

  const validateThis = () => {
    if (logComponent('RadioButtonListInput')) { console.debug('RadioButtonListInput validateThis'); }
    if (isValidating.current) return;
    isValidating.current = true;

    let validationDetailsThis = [];
    for (let rule in rules) {
      validationDetailsThis.push({
        rule: rule,
        valid: validate[rule](value, rules[rule])
      })
    }

    let isValidThis = validationDetailsThis.reduce((prev, curr) => prev && curr.valid, true);

    setValidationDetails(validationDetailsThis);
    setIsValid(isValidThis);


    onValidate({
      name: name,
      isValid: isValidThis,
      value: valueRef.current
    });
    isValidating.current = false;
  }

  return (
    <div className="Radio-Button-List-Input-Group">
      {
        showError && !isValid &&
        <p className="Radio-Button-List-Input-Group__error">{errorMessage}</p>
      }
      <label
        className="Radio-Button-List-Input-Group__label"
        htmlFor={name + '-input'}>
        {label}{
          rules && rules.required &&
          <span className="Radio-Button-List-Input-Group__required"> *</span>
        }
      </label>
      <RadioButtonGroup
        onChange={updateValue}
        name={name}
        initialSelection={initialValue}
        options={items}
        horizontal={ false }
      />

      
    </div>
  );
}